import { makeAutoObservable, runInAction } from "mobx";
import ApiStore from "./ApiStore";
import { UploadFile } from "antd";
import { NewTicket, Ticket, TicketStatus } from "../api/TicketApi";



export type TicketAssignKanban = {
  assigneeId: number;
  kanbanCompanyId: number;
  projectId: number;
  ticketPublicId: string;
  description: string;
};

class TicketStore {
  isLoading: boolean = true;
  ApiStore!: ApiStore;
  activeTickets!: Ticket[];
  closedTickets!: Ticket[];
  currentTicket!: Ticket | null;
  isLoadingAttachments: boolean = false;
  companyName: string;


  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
    this.activeTickets = [];
    this.closedTickets = [];
    this.currentTicket = null;
    this.companyName = "sktech";
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  createNew = async (item: NewTicket) => {
    this.isLoading = true;
    const response = await this.ApiStore.TicketApi.add(item);

    if (response.value) {
      runInAction(() => {
        this.activeTickets = [...this.activeTickets, response.value];
      });
    }
    this.isLoading = false;
    return response;
  }

  assignKanbanTask = async (item: TicketAssignKanban) => {
    this.isLoading = true;
    const response = await this.ApiStore.TicketApi.assignKanbanTask(item);
    this.activeTickets = [...this.activeTickets.map(ticket => {
      if (ticket.publicId === response.publicId) {
        ticket.kanbanCompanyId = response.kanbanCompanyId;
        ticket.kanbanProjectId = response.kanbanProjectId;
        ticket.kanbanTicketPublicId = response.kanbanTicketPublicId;
        ticket.kanbanResposibleUserId = response.kanbanResposibleUserId;
      }
      return ticket;
    })];
    this.isLoading = false;
    return response;
  }

  update = async (id: string, item: Ticket) => {
    this.isLoading = true;
    const response = await this.ApiStore.TicketApi.update(id, item);
    this.activeTickets = this.activeTickets.map(ticket => {
      if (ticket.publicId === item.publicId) {
        ticket.status = item.status;
      }
      return ticket;
    }
    );
    this.isLoading = false;
    return response;
  }

  getAllTickets = async () => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getAll().then((tickets) => {
      this.isLoading = false;
      if (tickets) {
        this.activeTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });

    return tickets;
  }

  getAllActiveTickets = async () => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getAllActive().then((tickets) => {
      this.isLoading = false;
      if (tickets) {
        this.activeTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });
    return tickets;
  }


  getAllCloseTickets = async () => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getAllClosed().then((tickets) => {
      this.isLoading = false;
      if (tickets) {
        this.closedTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });
    return tickets;
  }

  getMyTickets = async (tenautOrEmail: string) => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getMyTickets(this.companyName, tenautOrEmail).then((tickets) => {
      this.isLoading = false;
      if (tickets) {
        this.activeTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });

    return tickets;
  }
  setCurrentTicket = (ticket: Ticket) => {
    this.currentTicket = ticket;
  }
  getTicketsById = async (id: string) => {
    this.isLoading = true;
    const ticket = await this.ApiStore.TicketApi.getById(id).then((newticket) => {
      this.isLoading = false;
      if (newticket) {
        this.currentTicket = newticket;
      }
      return newticket;
    }).catch(() => {
      this.isLoading = false;
    });

    return ticket;
  }

  getMyTicketsActive = async (tenautOrEmail: string) => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getMyTicketsActive(this.companyName, tenautOrEmail).then((tickets) => {
      if (tickets) {
        this.activeTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      this.isLoading = false;
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });

    return tickets;
  }

  getMyTicketsClosed = async (tenautOrEmail: string) => {
    this.isLoading = true;
    const tickets = await this.ApiStore.TicketApi.getMyTicketsClosed(this.companyName, tenautOrEmail).then((tickets) => {
      this.isLoading = false;
      if (tickets) {
        this.closedTickets = tickets.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      return tickets;
    }).catch(() => {
      this.isLoading = false;
    });

    return tickets;
  }

}
export default TicketStore;
